import { takeLatest } from 'redux-saga/effects';

import { SET_BUY_PACKAGE_HELD_PAYMENT } from '../../actions/buyPackage';
import { payPackage } from './payPackage';

export function* payPackageSagas() {
  yield takeLatest([SET_BUY_PACKAGE_HELD_PAYMENT], payPackage);
}
